export const HEADER = 'Unsaved changes';
export const ARE_YOU_SURE_TEXT = 'Are you sure you want to leave this page?';
export const CHANGES_WONT_BE_SAVED = 'Changes will not be saved.';
